// src/game/Settings.js
// Persistent user settings — backed by localStorage.
// Defaults: music shuffle OFF, music volume 0.55, sfx volume 0.75.

const KEY = 'pazurumon_settings';
const DEFAULTS = {
  musicVolume:  0.55,
  sfxVolume:    0.75,
  musicShuffle: false,
  tileStyle:    'prism',   // 'classic' | 'prism' | 'themed'
};

let _cache = null;

function _load() {
  if (_cache) return _cache;
  try {
    _cache = { ...DEFAULTS, ...JSON.parse(localStorage.getItem(KEY) || '{}') };
  } catch {
    _cache = { ...DEFAULTS };
  }
  return _cache;
}

function _save() {
  localStorage.setItem(KEY, JSON.stringify(_cache));
}

export const Settings = {
  get musicVolume()  { return _load().musicVolume; },
  get sfxVolume()    { return _load().sfxVolume; },
  get musicShuffle() { return _load().musicShuffle; },
  get tileStyle()    { return _load().tileStyle; },

  setMusicVolume(v)  { _load().musicVolume  = Math.max(0, Math.min(1, v)); _save(); },
  setSfxVolume(v)    { _load().sfxVolume    = Math.max(0, Math.min(1, v)); _save(); },
  setMusicShuffle(v) { _load().musicShuffle = !!v; _save(); },
  setTileStyle(v)    { _load().tileStyle = ['classic','prism','themed'].includes(v) ? v : 'prism'; _save(); },
};
